export interface IProps {}

export enum CardType {
  Image = "image",
  Title = "title",
  Content = "content",
  ImageVertically = "image-vertically",
}

export type CardProps = {
  type: CardType;
  content: any;
  colSpan: number;
  rowSpan: number;
};
